import soulution1 from "../Assets/soultion/question-icon01.jpg";
import soulution2 from "../Assets/soultion/question-icon02.jpg";
import soulution3 from "../Assets/soultion/question-icon03.jpg";
import soulution4 from "../Assets/soultion/question-icon04.jpg";
import soulution5 from "../Assets/soultion/question-icon05.jpg";
import soulution6 from "../Assets/soultion/question-icon06.jpg";
import InfoCard from "./InfoCard";
const InfoSection = () => { 
    const cards = [
  {
    id: 1,
    badge: "Assistance Available",
    title: "Research / Dissertation Writing Help",
    description:
      "Refine your research and dissertation writing skills with expert guidance. Get support in crafting well-structured and compelling academic documents.",
    image: soulution1,
    buttonText: "Know More",
  },
  {
    id: 2,
    badge: "Expert Guidance Available",
    title: "Essay Writing",
    description:
      "Improve your essay writing with professional support. We help you create clear, structured, and high-scoring essays.",
    image:soulution6,
    buttonText: "Know More",
  },
  {
    id: 3,
    badge: "Expert Assistance",
    title: "Summary Writing",
    description:
      "Get concise and accurate summaries written by experts while maintaining clarity, meaning, and structure.",
    image: soulution2,
    buttonText: "Know More",
  },
  {
    id: 4,
    badge: "Professional Guidance",
    title: "Presentation Writing Help",
    description:
      "Create impactful and professional presentations with expert-written content and well-organized slides.",
    image: soulution3,
    buttonText: "Know More",
  },
  {
    id: 5,
    badge: "Assistance Available",
    title: "Project Lab Report Writing Help",
    description:
      "Get expert help for lab reports and projects with accurate formatting, explanations, and structured content.",
    image: soulution4,
    buttonText: "Know More",
  },
  {
    id: 6,
    badge: "Support Service",
    title: "Problem Solving",
    description:
      "Solve complex academic problems with expert support and step-by-step explanations.",
    image:  soulution5,
    buttonText: "Know More",
  },
];

    return (
          <div className="info-section">
      <div className="container">
        <div className="row g-4">
          {cards.map((card) => (
            <div
              key={card.id}
              className="col-12 col-sm-6 col-lg-4"
            >
              <InfoCard {...card} />
            </div>
          ))}
        </div>
      </div>
    </div>
    )
}   
export default InfoSection;